import formatProgressCount from './formatProgressCount';

const EM_DASH = '—';

const formatProgressDisplayValue = (value: number | null | undefined, locale: string): string => {
  if (value === null || value === undefined) {
    return EM_DASH;
  }

  return formatProgressCount(value, locale);
};

export default formatProgressDisplayValue;
